document.addEventListener('DOMContentLoaded', ()=> {
  setTimeout(() => {
    
  
  var zi = function (t, e, n, r) {
    if (
      ((this.configuratorIframe = document.getElementById(t)),
      this.configuratorIframe)
    ) {
      (this.configuratorEndpoint = e),
        (this.domain = n),
        (this.redirectUrl = r),
        this._listenToMessages();
      var i = this;
      function openConfigurator(t){
        i.openConfigurator.bind(i)();
      }
      Array.from(
        document.querySelectorAll("[data-configurator-iframe-open]")
      ).forEach(function (t) {
        console.log(t);
        t.addEventListener("click", function () {
          i.openConfigurator.bind(i)();
        });
      });
    }
  };
  (zi.prototype._listenToMessages = function () {
    var t = this;
    window.addEventListener("message", function (e) {
      e.origin === t.domain &&
        (("close-iframe" !== e.data && "close-iframe" !== e.message) ||
          t.closeConfigurator(),
        "change-cart" === e.data.event_id &&
          t._addOrChangeCart(
            e.data.data.variantid,
            e.data.data.quantity || 1
          ));
    });
  }),
    (zi.prototype.openConfigurator = function () {
      document.querySelector('.configurator_aside').classList.remove('hidden')
      document.querySelector("[data-sidebar-configurator-toggle]").click(),

        this.configuratorIframe.src ||
          (this.configuratorIframe.src = this.configuratorEndpoint),
        (this.configuratorIframe.style.display = "block");
    }),
    (zi.prototype.closeConfigurator = function () {
      var t = this;
      
      document.querySelector("[data-sidebar-configurator-toggle]").click(),
        (this.configuratorIframe.style.display = "none"),
        this.redirectUrl &&
        //   setTimeout(function () {
        //     window.location.href = t.redirectUrl;
        //   }, 800),
        document.querySelector("[data-sidebar]").classList.add("hidden");
    }),
    (zi.prototype._addOrChangeCart = function (t, e) {
      var n = this;
      fetch("/cart.js")
        .then(function (t) {
          return t.json();
        })
        .then(function (r) {
          var i, o, s;
          r.items.some(function (e) {
            return e.id.toString() === t.toString();
          })
          
            ? n._callCart("/cart/update.js", {
                updates:
                  ((i = {}),
                  (o = t),
                  (s = e),
                  o in i
                    ? Object.defineProperty(i, o, {
                        value: s,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                      })
                    : (i[o] = s),
                  i),
              })
            : n._callCart("/cart/add.js", {
                items: [{ id: t, quantity: e }],
              });
        });
    }),
    (zi.prototype._callCart = function (t, e) {
      fetch(t, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(e),
      })
        .then(function (t) {
          return t.json();
        })
        .catch(function (t) {
          console.error("Error:", t);
        });
    });
    new zi(
          "configuratorIframe",
          "https://configure.carrodrain.com/?m=chart",
          "https://configure.carrodrain.com",
          "/cart" 
    );

    var Lr = function (t, e) {
          (this.sidebar = document.querySelector(t)),
            (this.toggles = Array.from(document.querySelectorAll(e))),
            (this.isOpen = !1),
            window.onSidebarNavigationToggleClick &&
              this.toggles.forEach(function (t) {
                t.removeEventListener(
                  "click",
                  window.onSidebarNavigationToggleClick
                );
              }),
            (window.onSidebarNavigationToggleClick =
              this._toggleSidebar.bind(this)),
            this.toggles.forEach(function (t) {
              t.addEventListener(
                "click",
                window.onSidebarNavigationToggleClick
              );
            });
        };

    (Lr.prototype._toggleSidebar = function () {
        this.isOpen ? this._hideSidebar() : this._showSidebar(),
          (this.isOpen = !this.isOpen);
      }),
        (Lr.prototype._showSidebar = function () {
          this.sidebar.classList.remove("hidden");
        }),
        (Lr.prototype._hideSidebar = function () {
          this.sidebar.classList.add("hidden");
        });
        new Lr("[data-sidebar]", "[data-sidebar-toggle]"),
        new Lr(
          "[data-sidebar-configurator]",
          "[data-sidebar-configurator-toggle]"
        )
      }, 1000);
})